module.exports = __webpack_public_path__ + "img/settings.70a77671.svg";